import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

import * as VueGoogleMaps from 'vue2-google-maps'
 
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAelB3o63vVXomc5KF-iQ8CDNJNo6fIEl0',
  },
 })

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
